import SettingHome from "../../entities/Settings/SettingHome";

const Settings = () => {

  return (
    <SettingHome
    />
  )
};
export default Settings;
